import React from 'react';
import cssmodules from 'react-css-modules';
import styles from './initiativetable.cssmodule.scss';
import TableFilterHeader from '../Shared/TableFilterHeader';
import { Link } from 'react-router';
import classNames from 'classnames';
import { injectIntl, intlShape, FormattedRelative } from 'react-intl';
import { Button, Glyphicon, MenuItem, DropdownButton } from 'react-bootstrap';
import { FormattedDate } from 'react-intl';
import { convertInitiativeStateName, INITIATIVE_TYPE } from '../../constants';
import IdeaStateLabel from '../Shared/IdeaStateLabel';
import Pager from '../Shared/Pager';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import UserSelect from '../Shared/UserSelect';
import Select from 'react-select';

class InitiativeTable extends React.Component {

  constructor(props) {
    super(props);
    const { intl } = props;
    const { storedFilter } = props;
    const t = (message, data = {}) => {
      if (!message) return '';
      return intl.formatMessage({ id: message }, data);
    };

    const initialFilter = storedFilter ? { ...storedFilter } : {
      State: -1,
      UserId: -1,
      TypeId: -1
    };

    this.state = {
      filterEnabled: true,
      filter: initialFilter,
      dateRanges: {
        [t('All')]: [moment().add(-100, 'years'), moment().add(1, 'years')],
        [t('Last 7 Days')]: [moment().subtract(6, 'days'), moment()],
        [t('Last 30 Days')]: [moment().subtract(29, 'days'), moment()],
        [t('This Month')]: [moment().startOf('month'), moment().endOf('month')],
        [t('Last Month')]: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        [t('This Year')]: [moment().startOf('year'), moment()]
      },
      dateRange: {
        CreatedEnd: moment().add(1, 'years'),
        CreatedStart: moment().add(-100, 'years')
      }
    };
  }

  componentWillReceiveProps(nextProps) {
    const { storedFilter } = nextProps;
    if (storedFilter && storedFilter !== this.props.storedFilter) {
      this.setState({
        filter: { ...storedFilter }
      });
    }
  }

  handleNextPage() {
    const { loadNextPage } = this.props;
    loadNextPage(this.state.filter);
  }

  handlePrevPage() {
    const { loadPrevPage } = this.props;
    loadPrevPage(this.state.filter);
  }

  toggleFilter(event) {
    this.setState({
      filterEnabled: !this.state.filterEnabled
    });
  }

  handleCreatedRangeChange(event, picker) {
    var filter = {
      ...this.state.filter,
      CreatedStart: picker.startDate.format('YYYY-MM-DD'),
      CreatedEnd: picker.endDate.format('YYYY-MM-DD'),
    };
    const { filterChanged } = this.props;
    if (filterChanged) {
      filterChanged(filter);
    }
    this.setState({
      filter: filter,
      dateRange: {
        CreatedStart: picker.startDate,
        CreatedEnd: picker.endDate,
      }
    });
  }

  handleFilterChange(propertyName, event) {
    var newValue;
    if (typeof event === 'object') {
      newValue = event.target.value;
    }
    else {
      newValue = event;
    }
    // Don't trigger filter change if value hasn't actually changed
    if (newValue === this.state.filter[propertyName]) {
      return;
    }
    var filter = { ...this.state.filter, [propertyName]: newValue };
    //fire filter changed
    const { filterChanged } = this.props;
    if (filterChanged) {
      filterChanged(filter);
    }
    this.setState({
      filter: filter
    });
  }


  handleTypeSelect(evt) {
    const newTypeId = evt ? evt.Id : -1;
    // Don't trigger filter change if value hasn't actually changed
    if (newTypeId === this.state.filter.TypeId) {
      return;
    }
    var filter = { ...this.state.filter, 'TypeId': newTypeId };
    this.setState({
      filter: filter
    });
    const { filterChanged } = this.props;
    if (filterChanged) {
      filterChanged(filter);
    }
  };


  onSelectUserFilter(propertyName, usr) {
    const newUserId = usr ? usr.Id : 0;
    // Don't trigger filter change if value hasn't actually changed
    if (newUserId === this.state.filter[propertyName]) {
      return;
    }
    var filter = { ...this.state.filter, [propertyName]: newUserId, User: usr || null };
    const { filterChanged } = this.props;

    if (filterChanged) {
      filterChanged(filter);
    }

    this.setState({
      filter: filter,
    });
  }

  render() {
    const { intl } = this.props;
    const t = (message, data = {}) => {
      if (!message) return '';
      return intl.formatMessage({ id: message }, data);
    };
    const { initiativePage } = this.props;
    const { initiativeTypes } = this.props;
    const { authInfo } = this.props;
    const { IsAdmin } = authInfo;


    return (
      <div className="brand-panel panel panel-default filterable initiativetable-component" styleName="initiativetable-component">
        <div className="panel-heading">
          <h3 className="panel-title">{t('Initiatives')}
            {
              initiativePage.Loading && (<span className="fa fa-refresh fa-spin" style={{ marginLeft: '10px' }}></span>)
            }
          </h3>
          <div className="pull-right">
            <button title={t('Toggle table filter')} className="btn btn-default btn-xs btn-filter" onClick={this.toggleFilter.bind(this)}><span className="glyphicon glyphicon-filter"></span>
              {t('Filter')}
            </button>
          </div>
        </div>
        <div className=" panel-body table-responsive" styleName="table-container">
          <Pager pageIndex={initiativePage.PageIndex} totalPageCount={initiativePage.TotalPageCount}
            nextClick={this.handleNextPage.bind(this)}
            prevClick={this.handlePrevPage.bind(this)} />

          <table className="table">
            <thead>
              <tr>
                <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('Id')}>
                  <input type="text" className="form-control input-sm" placeholder={t('Id')} value={this.state.filter.InitiativeId || ''} onChange={this.handleFilterChange.bind(this, 'InitiativeId')} />
                </TableFilterHeader>
                <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('Created')}>
                  <DateRangePicker autoUpdateInput={false} startDate={this.state.dateRange.CreatedStart} endDate={this.state.dateRange.CreatedEnd} ranges={this.state.dateRanges} onApply={this.handleCreatedRangeChange.bind(this)}>
                    <Button className="selected-date-range-btn" style={{ width: '100%' }} bsSize="small">
                      <Glyphicon glyph="calendar" />
                    </Button>
                  </DateRangePicker>
                </TableFilterHeader>
                <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('Title')}>
                  <input type="text" className="form-control input-sm" placeholder={t('Title')} value={this.state.filter.Title || ''} onChange={this.handleFilterChange.bind(this, 'Title')} />
                </TableFilterHeader>

                <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('Type')}>
                  <Select placeholder={t('Select') + ' ...'}
                    value={this.state.filter.TypeId}
                    options={initiativeTypes.Types}
                    onChange={this.handleTypeSelect.bind(this)}
                  />
                </TableFilterHeader>
                <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('Status')}>
                  <DropdownButton value={this.state.filter.State} onSelect={this.handleFilterChange.bind(this, 'State')} title={t(convertInitiativeStateName(this.state.filter.State))} id="dd-filter-state" className="btn-brand btn btn-default btn-sm">
                    <MenuItem eventKey="-1">{t(convertInitiativeStateName(-1))}</MenuItem>
                    <MenuItem eventKey="1">{t(convertInitiativeStateName(1))}</MenuItem>
                    <MenuItem eventKey="2">{t(convertInitiativeStateName(2))}</MenuItem>
                    <MenuItem eventKey="3">{t(convertInitiativeStateName(3))}</MenuItem>
                    <MenuItem eventKey="4">{t(convertInitiativeStateName(4))}</MenuItem>
                    <MenuItem eventKey="5">{t(convertInitiativeStateName(5))}</MenuItem>
                    <MenuItem eventKey="6">{t(convertInitiativeStateName(6))}</MenuItem>
                    <MenuItem eventKey="7">{t(convertInitiativeStateName(7))}</MenuItem>
                  </DropdownButton>
                </TableFilterHeader>
                {
                  !this.state.filterEnabled && (<th>{t('Idea originator')}</th>)
                }
                {
                  !this.state.filterEnabled && (<th>{t('Responsible person')}</th>)
                }
                {
                  this.state.filterEnabled && (
                    <th colSpan="2" style={{ minWidth: '150px' }}>
                      <UserSelect
                        compact={true}
                        key={this.state.filter.UserId}
                        userId={this.state.filter.UserId}
                        user={this.state.filter.User}
                        onSelectUser={this.onSelectUserFilter.bind(this, 'UserId')}
                      />
                    </th>
                  )
                }
                <TableFilterHeader filterEnabled={this.state.filterEnabled} label={t('Modified')}>
                  <p className="form-control-static"> {t('Modified')}</p>
                </TableFilterHeader>
              </tr>
            </thead>
            <tbody>
              {initiativePage.TotalCount == 0 && <tr>
                <td colSpan="8">
                  <div className="alert alert-warning">
                    <strong>Oops!</strong>&nbsp;{t('NO_DATA')}
                  </div>
                </td>
              </tr>
              }
              {
                initiativePage.Data.map((i, idx) =>
                (<tr key={i.Id} className={classNames({
                  'warning': i.State == 2 || i.State == 3 || i.State == 6,
                  'success': i.State == 4,
                  'danger': i.State == 5
                })}>
                  <td><Link to={"/process-initiative/" + i.Id}>{i.Id}</Link></td>
                  <td><FormattedDate value={i.Created} /></td>
                  <td><Link to={"/process-initiative/" + i.Id}>{i.Title}</Link></td>
                  <td>{i.Type.label}</td>
                  <td><IdeaStateLabel type={INITIATIVE_TYPE} state={i.State} /></td>
                  <td>{i.HideName && !IsAdmin ? '-' : i.AuthorDisplayNames}</td>
                  <td>{i.Manager.DisplayName}</td>
                  <td><FormattedDate value={i.LastModified} /></td>
                </tr>)
                )
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

InitiativeTable.displayName = 'InitiativeTable';
InitiativeTable.propTypes = {};
InitiativeTable.defaultProps = {};

export default injectIntl(cssmodules(InitiativeTable, styles));


// WEBPACK FOOTER //
// ./components/BrowseIdeas/InitiativeTable.js